import { createContext, useReducer } from "react";

export const AuthContext = createContext()


export const authReducer = (state, action) => {
    switch (action.type) {
        case "WELCOMEBACK":
            return{...state, user: action.payload}
        case "LOGIN":
            localStorage.setItem("user", JSON.stringify(action.payload))
            return{...state, user: action.payload}
        case "LOGOUT":
            localStorage.removeItem("user")
            window.location.reload(false);
            return{...state, user: {}}
        default:
            return state
    }
}

export const AuthContextProvider = ({children}) => {

    const [state, dispatch] = useReducer(authReducer, {
        user: null
    })
    
    console.log('AuthContext State', state)
    return (
        <AuthContext.Provider value={{...state, dispatch}}>
            {children}
        </AuthContext.Provider>
    )
}